/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';
import { getContentItemForSlot } from '@/data/utils/getContentItemForSlot';

export const getIntertoysProductPageContainer_rv = (props: IncomingContent): Layout => ({
	name: 'IntertoysProductPageLayout_rv',
	slots: {
		header: [{ name: 'Header', id: 'header' }],

		first: getContentItemForSlot(props, 'first'),
		second: getContentItemForSlot(props, 'second'),
		third: getContentItemForSlot(props, 'third'),
		fourth: getContentItemForSlot(props, 'fourth'),
		fifth: getContentItemForSlot(props, 'fifth'),
		six: getContentItemForSlot(props, 'six'),
		seven: getContentItemForSlot(props, 'seven'),
		eight: getContentItemForSlot(props, 'eight'),
		nine: getContentItemForSlot(props, 'nine'),
		ten: getContentItemForSlot(props, 'ten'),

		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
